export default "__VITE_ASSET__C8VJkpZl__";